import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '../../../typings'
import { ISalesFunnelStage } from '@user/store/salesFunnel'

export function useHandlers({ name }) {
  const { setFieldValue } = useFormikContext<ILeadFormModel>()

  const handelChange = useCallback(
    (value: ISalesFunnelStage | null) => {
      setFieldValue(name, value?.id)
    },
    [name, setFieldValue],
  )

  return {
    handelChange,
  }
}
